import FetchWrapper from '../Common/Wrappers/FetchWrapper';
import { Service } from '../Common/service.enum';
import Logging from '../../Logging/Logging';
import {
  BulkUploadRequest,
  BulkUploadResponse,
  BulkUploadStatusReasonUpdate,
  BulkUploadStatusUpdate,
  BulkUploadStatus,
  BulkUploadSummaryCollection,
} from '../../..';

export default class BulkUploadRepo {
  private fetch: FetchWrapper;

  constructor(fetch: FetchWrapper) {
    this.fetch = fetch;
  }

  getBulkUploadHistoryV4(startRow: number, endRow: number): Promise<BulkUploadSummaryCollection> {
    const apiServiceEndpoint = 'portal/v4/bulk-upload';
    const numberRows = endRow > startRow ? endRow - startRow : 0;
    const pagingQueryParam = `&$top=${numberRows}&$skip=${startRow}&$count=true`;

    let queryParams = '';

    // Add the Paging Parameters
    if (pagingQueryParam) {
      queryParams += queryParams === '' ? `?${pagingQueryParam}` : pagingQueryParam;
    }

    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<BulkUploadSummaryCollection>(Service.ECM, url);
  }

  editBulkUploadHistoryV4(uuid: string, status: BulkUploadStatus, reason: string): Promise<void> {
    const apiServiceEndpoint = `portal/v4/bulk-upload/${uuid}`;

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    const request: any [] = []; // eslint-disable-line @typescript-eslint/no-explicit-any

    // Replace the Status of the Bulk Upload
    const bulkUploadStatus: BulkUploadStatusUpdate = {
      op: 'replace',
      path: '/status',
      value: status,
    };
    request.push(bulkUploadStatus);

    // Add the Reason if it is defined
    if (reason) {
      const bulkUploadStatusReason: BulkUploadStatusReasonUpdate = {
        op: 'replace',
        path: '/reason',
        value: reason,
      };
      request.push(bulkUploadStatusReason);
    }

    Logging.Info('PATCH', url, request);
    return this.fetch.patchToService<void>(Service.ECM, url, request);
  }

  submitBulkUploadV4(bulkUpload: BulkUploadRequest): Promise<BulkUploadResponse> {
    const apiServiceEndpoint = 'portal/v4/bulk-upload';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('POST', url, bulkUpload);
    return this.fetch.postToService<BulkUploadResponse>(Service.ECM, url, bulkUpload);
  }
}
